<template >
<div class="">  
<waitingModal v-if="waitModal.show == true" @close="closeWaitingModal()"  v-bind:props="waitModal" ></waitingModal>  
<div v-if="customerId>0">
<form class="form-inline" v-on:submit.prevent="submit()">

  <div class="form-group mx-sm-3 mb-2 mt-4">
    <label for="inputPassword2" class="sr-only">QUOTA ASSOCIATIVA</label>

     <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text">€</div>
        </div>
    <input v-focus required type="number" class="form-control"  ref="inputTotal" placeholder="Quota associativa" v-model="club.total">
  </div>
  </div>
  <button v-if="club.customerId > 0" :disabled="spinner" type="submit" class="btn btn-primary mb-2 mt-3">
    
    
    REGISTRA QUOTA
    <i  style="color:#FFCC00" class="fas fa-save ml-3" aria-hidden="true"></i>
   <span v-if="spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
  </button>

</form>
<p class="mt-3"><strong>PAGAMENTI QUOTA</strong></p>
 <li class="ml-3" v-for="(item, index) in items">
  {{ item.create_at }} -  € {{ fmt1(item.total) }} 

  <button  @click="deleteRow(item.rowId,index)" title='Elimina quota' class="btn btn-light ml-3">
        
    <i  style="color:red"  class="fas fa-trash " aria-hidden="true"></i>
        
        
  </button>

</li>     



  
<p class="mt-3"><strong>PERSONE</strong></p>
<button  v-if="persons.length < 2" @click="addPerson()" title='Aggiungi persona' class="btn btn-light mb-2 ml-3">
  <i   class="fas fa-plus mr-2" aria-hidden="true"></i> AGGIUNGI PERSONA
</button>
 



<li class="ml-3" v-for="(item, index) in persons">
  
<form v-on:submit.prevent="savePersons(item)">
    <div class="row mb-1">
      
      <button :disabled="!item.rowId" type="button"  @click="deletePerson(item.rowId,index)" title='Elimina persona' class="btn btn-secondary ml-3">
        <i  style="color:black"  class="fas fa-trash " aria-hidden="true"></i>             
      </button>
      
      <button   title='Registra persona' class="btn btn-success  ml-4"  type="submit">
           
        <i   class="fas fa-save ml-2" aria-hidden="true"></i>
      </button>


    <div class="col">
      
      <input v-focus required type="text" class="form-control" placeholder="Cognome" v-model="item.Cognome">
    </div>
    <div class="col">
      <input required type="text" class="form-control" placeholder="Nome" v-model="item.Nome">
    </div>
    <div class="col">
      <input required type="text" class="form-control" placeholder="Data di nascita" v-model="item.DataNascita">
    </div>
    <div class="col">
      <input required type="text" class="form-control" placeholder="Telefono" v-model="item.Telefono">
    </div>  




  </div>
</form>  

  

</li>  

<button  v-if="persons.length > 100"  title='Aggiungi persona' class="btn btn-primary mt-2 ml-4"  type="submit">
   REGISTRA PERSONE
   <i   class="fas fa-save ml-2" aria-hidden="true"></i>
</button>



 



</div>

<alert-box @close="msg.title=''" v-bind:msg="msg" class="mt-2 mb-2"  ></alert-box>

</div>
</template>
<script>

import api                        from '@/api'
import alertBox                   from '@/components/common/AlertBox.vue';
import { mapGetters }             from 'vuex';
import waitingModal               from "@/components/common/WaitingModal.vue"  
import fmt                        from '@/components/mixins/fmt.js'

export default {
  components : {alertBox,waitingModal},
  mixins     : [fmt],   
  props      : ['customerId'] , 
 data () {
    return {
    
      items        : [],  
      waitModal    : {

        sentinel   : 0,
        show       : false,
        msg1       : 'REGISTRAZIONE IN CORSO ...',
        msg2       : '' 

      },  
       
    club     : {'customerId':0,'storeId':0,'deskId':0},    
    spinner  : false,
    persons  : [],    
    
    msg : {
        title : '',
        body  : '',
        type  : 0
      }


    }
  },
  directives: 
    {
      focus: {
      
        inserted: function (el) {
          
          el.focus()
          }
           
       
      }
    },

  computed: {
    ...mapGetters(['company','storeId','isAdmin']) 
  },

  
mounted()
{
    this.msg.title = '' 
    
    this.$nextTick(() => {
        this.getData(this.customerId)
    
           //$('#recipient').trigger('focus');
      })
 
},  
created()
{ 
  //console.log('CREATE BILLING',this.customerId)  
 
  this.msg.title = ''  
  this.club.customerId = this.customerId
    
},

methods :{

addPerson()
{
  this.persons.push({'Cognome':'','Nome':'','DataNascita':'','Telefono':'','rowId':''})
},

async deletePerson(rowId,index)
{
  
  
  this.msg.title = ''
  const sp    = {'sp'    : 'spDeleteCustomerClubPerson'}  
  const data  = {"rowId" : rowId}
  
  
  
  
  const json  = Object.assign(data, sp)

  this.spinner = true
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
                           
             this.persons.splice(index, 1);
                         
            }
           else if(res.status==500)
           {
               
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                                 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });
 


},

async deleteRow(rowId,index)
{
  
  
  this.msg.title = ''
  const sp    = {'sp' : 'spDeleteCustomerSapiaClub'}  
  const data  = {"rowId":rowId}
  const json  = Object.assign(data, sp)

  this.spinner = true
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
                           
             this.items.splice(index, 1);
                         
            }
           else if(res.status==500)
           {
               
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                                 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });
 


},  
closeWaitingModal()
    {
      this.waitModal.show = false
      this.waitModal.sentinel = 0
      
    },
 
initClub()
{
  

  //this.billing.typeId    = 'CASH'
  
},
async submit()
{

 

  this.msg.title       = ''  
  this.club.customerId = this.customerId  
  const deskId         = JSON.parse(localStorage.getItem("deskId"))
  this.club.deskId     = deskId  
  this.club.storeId    = this.storeId
  const sp             = {'sp'   : 'spCreateCustomerSapiaClub'}
  
  const json           = Object.assign(this.club, sp)
  
  this.spinner = true
  this.waitModal.show  = true   
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
              
              this.waitModal.sentinel = 1 
              this.msg.title = 'REGISTRAZIONE EFFETTUATA.'
              this.msg.body  = ''
              this.msg.type  = 0
              this.getData(this.club.customerId)
              this.club.total = ''
              this.club.create_at = ''
 
                                                                  
            }
           else if(res.status==500)
           {               
                this.waitModal.sentinel = 3  
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                this.waitModal.sentinel = 2                 
                
                /*
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                */
                
                 
            } 
        
          }).catch(err => {
              
              this.waitModal.sentinel = 3
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });


},

async savePersons(item)
{


  this.msg.title       = ''  
  
  const persons         = []
  persons.push(item)

  const sp             = {'sp'   : 'spCreateCustomerClubPersons'}    
  const data           = {'customerId':this.customerId,'rowId':item.rowId,'persons':persons}
  const json           = Object.assign(data, sp)
  
  this.spinner = true
  this.waitModal.show  = true   
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
              
              this.waitModal.sentinel = 1 
              this.msg.title = 'REGISTRAZIONE EFFETTUATA.'
              this.msg.body  = ''
              this.msg.type  = 0
              this.getData(this.club.customerId)
             
 
                                                                  
            }
           else if(res.status==500)
           {               
                this.waitModal.sentinel = 3  
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                this.waitModal.sentinel = 2                 
                
                /*
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                */
                
                 
            } 
        
          }).catch(err => {
              
              this.waitModal.sentinel = 3
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });


},




async getData(customerId)
{
  
  this.items = []  
  this.persons = []
 // this.msg.title = ''
  const sp    = {'sp'         : 'spCustomerSapiaClub'}  
  const data  = {"customerId" : customerId}
  const json  = Object.assign(data, sp)

  this.spinner = true
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
              
              
           
                        
              if(res.data.recordsets[0].length > 0)         
              {

                this.items = res.data.recordsets[0]
                this.persons = res.data.recordsets[1]
                        
                
              }
                         
            }
           else if(res.status==500)
           {
               
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                                 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });
 
},



}

}

</script>
<style scoped>

label{
    font-weight: bold;
}
</style>
